import React, { useState, useEffect } from "react";
import { object } from "prop-types";
import get from "lodash/get";
import Separator from "../../atoms/separator";
import ElectionConstituencySearchBar from "../../atoms/election-constituency-search-bar";

import {
  stateElections2024AllRecords,
  lokSabhaElectionData2024AllRecords
} from "../../molecules/election-brick-wall-with-search/election-data-2024";

const Records = [...stateElections2024AllRecords, ...lokSabhaElectionData2024AllRecords];

import "./collection-widget-with-search.m.css";

const CollectionWidgetWithSearch = ({ collection }) => {
  const [pathname, setPathname] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      const pathname = window.location.pathname.slice(1);
      setPathname(pathname);
    }
  }, []);

  const content = get(collection, ["associated-metadata", "content"], "");

  return (
    <div styleName="border-wrapper">
      <div styleName="wrapper" dangerouslySetInnerHTML={{ __html: content }}></div>
      {/* {stateElections2024SlugData.map((statedata) => {
        return statedata?.slug === pathname && <ElectionConstituencySearchBar Records={Records} />;
      })} */}
      <ElectionConstituencySearchBar Records={Records} />
      <Separator />
    </div>
  );
};

CollectionWidgetWithSearch.propTypes = {
  collection: object
};

export default CollectionWidgetWithSearch;
